<mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
  <mat-tab label="{{ 'Details' | transloco }}">
    <div class="sidebar-content--detail-tab">
      <div class="sidebar-content--detail-tab__container-content" data-userguide="editor-sidebar_content">
        <sidebar-title-description [disableDescription]="true" [title]="widget().title" (titleChange)="setTitle($event)" />

        <tt-divider class="tt-guideline-sidebar_divider" />

        <tt-guideline-component-sidebar-basics
          [attachments]="widget().attachments"
          [links]="widget().links"
          [references]="widget().references"
          [resourceTags]="widget().resourceTags"
          (basicsChanged)="handleBasicsChanged($event)" />
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
